var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStatusCheck = function SvgStatusCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.656 14.01 1.572 8.977l.792-.798 4.292 4.249 8.979-8.89.792.8-9.77 9.672z",
    fill: "#646464"
  })));
};
export { SvgStatusCheck as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik02LjY1NiAxNC4wMSAxLjU3MiA4Ljk3N2wuNzkyLS43OTggNC4yOTIgNC4yNDkgOC45NzktOC44OS43OTIuOC05Ljc3IDkuNjcyeiIgZmlsbD0iIzY0NjQ2NCIvPgo8L3N2Zz4K";